import AppButton from "@/components/AppButton.vue";
import HeaderFluxo from "@/components/HeaderFluxo.vue";
import HeaderModality from "@/components/HeaderModality.vue";
import HeaderRelease from "@/components/HeaderRelease.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import OptionField from "@/components/OptionField.vue";
import TextLink from "@/components/TextLink.vue";
import Request from "@/ts/Request";
import SelectFieldController from "@/ts/SelectFieldController";
import Util from "@/ts/Util";
import moment from "moment";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";

declare let Card: any;
@Component({
  components: {
    TextLink,
    HeaderFluxo,
    OptionField,
    ModalCodigo,
    HeaderRelease,
    HeaderModality,
    AppButton,
    HeaderColor,
  },
})
export default class AddCard extends Vue {
  numberCard: any = "";
  numberCardValid = true;
  numberCardValidDis = true;
  numberCardRules: any = [
    (v: any) => !!v || "Por favor, preencha o número do cartão",
    (v: any) =>
      this.numberCardValidate() == true || "Número de cartão inválido",
  ];
  oldNumberCard: any = "";
  cardFullName: any = "";
  fullNameValid = true;
  fullNameValidDis = true;
  fullNameRules: any = [
    (v: any) => !!v || "Por favor, preencha o nome impresso no cartão",
    (v: any) => this.fullNameValidate() == true || "Nome inválido",
  ];
  flagCard: any = "";
  cardFlag: any = "";
  expirationDate: any = "";
  expiryDateValid = true;
  expiryDateValidDis = true;
  expiryDateRules: any = [
    (v: any) => !!v || "Por favor, preencha a data de expiração do cartão",
    (v: any) =>
      this.expiryDateValidate() == true || "Data de expiração inválida",
  ];
  cvvCard: any = "";
  cvvValid = true;
  cvvValidDis = true;
  cvvCardRules: any = [
    (v: any) => !!v || "Por favor, preencha o CVV do cartão",
    (v: any) => this.cvvValidate() == true || "CVV inválido",
  ];
  reqType = "login";
  showModal = false;
  showModalCpf = false;
  showModalEmail = false;
  showModalSuccess = false;
  errorMessage =
    "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde.";
  allFlags: any = [
    { id: "0", name: "Visa", originalName: "Visa" },
    { id: "1", name: "MasterCard", originalName: "Master Card" },
    { id: "2", name: "Amex", originalName: "Amex" },
    { id: "3", name: "Diners", originalName: "Dinners" },
    { id: "4", name: "Elo", originalName: "Elo" },
  ];
  organizationDta: any = JSON.parse(
    sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
  );
  hasGatway: boolean = this.organizationDta.CONFIGURATIONS.GATEWAY.MERCHANT_ID
    ? true
    : false;
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "{}");
  cpf = "";
  cpfValidDis = true;
  cpfRules: any = [
    (v: any) => !!v || "Por favor, preencha o número do cpf",
    (v: any) => this.validateCpf("half") == true || "Digite um cpf válido",
  ];
  documentType = "";
  cpfError = "";
  email = "";
  emailError = "";
  flagVr = sessionStorage.getItem("FLAG_VR")
    ? sessionStorage.getItem("FLAG_VR")
    : null;
  profile: any = this.userData.USER_PROFILES.find(
    (profile: any) => profile.NRORG == sessionStorage.getItem("NRORG")
  );
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    show: true,
    callback: this.goBack,
  };
  store: any = JSON.parse(sessionStorage.getItem("STORE") || "{}");
  e1 = 1;
  noCpf = false;
  disabledCpfField = false;
  nrorg: any = JSON.parse(sessionStorage.getItem("NRORG") || "{}");

  mounted() {
    Util.setBackButtonBehavior(this.goBack);
    this.buildCardView();
    this.$nextTick(() => {
      SelectFieldController.refresh();
    });
    if ($("#EXPIRATION_DATE").prop("placeholder") != "")
      $("#EXPIRATION_DATE_LABEL").addClass("active");

    $("#NUMBERS")[0].onkeyup = this.verifyCardFlag;
  }

  setRandomEmail() {
    const fullNameFormatted = this.userData.FULL_NAME.normalize("NFD")
      .replace(/[\u0300-\u036f ]/g, "")
      .toLowerCase();

    const mainPhoneFormatted = this.userData.MAIN_PHONE.slice(-4);
    const randomEmailFormatted =
      fullNameFormatted + mainPhoneFormatted + "@gmail.com";

    return randomEmailFormatted;
  }

  addCreditCard() {
    if (!(<HTMLFormElement>$("form")[0]).checkValidity()) {
      this.mostraModal("Por favor, preencha todos os campos obrigatórios.");
      return;
    }
    if (this.flagCard == "") {
      this.mostraModal(
        "Infelizmente não aceitamos esse cartão. Verifique se o cartão é de crédito e se a bandeira está listada acima."
      );
      return;
    }
    // if (!this.userData.CPF || this.oldNumberCard !== this.numberCard) {
    //   this.mostraModalCpf(
    //     "Por segurança, favor informar o CPF do titular do cartão"
    //   );
    //   return;
    // }

    // if (!this.profile.EMAIL || this.oldNumberCard !== this.numberCard) {
    //   this.mostraModalEmail("Por último, digite seu e-mail");
    //   return;
    // }

    this.email =
      this.profile != "" || this.profile != null ? this.profile.EMAIL : "";

    const fullNameFormatted = this.cardFullName
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    try {
      const self = this;
      const req = new Request();
      req.body = {
        GEN_USER_ID: sessionStorage.getItem("USER_ID") || "",
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        NUMBERS: String(this.numberCard.split(" ")).replace(/,/g, ""),
        CARD_FULL_NAME: fullNameFormatted.toUpperCase(),
        FLAG: this.flagCard,
        CVV: this.cvvCard,
        EXPIRATION_DATE: String(this.expirationDate.split(" ")).replace(
          /,/g,
          ""
        ),
        NRORG: sessionStorage.getItem("NRORG"),
        DOCUMENT_TYPE: this.documentType,
        CPF: this.noCpf ? "" : this.userData.CPF,
        EMAIL:
          this.email == "" || this.email == null
            ? this.setRandomEmail()
            : this.email,
        STORE_ID: this.store.id,
        VOUCHER_FLAG: sessionStorage.getItem("VOUCHER_FLAG"),
      };
      req.route = "addCreditCard";
      // req.visibilityOptions = { success: false, error: false, loading: true };
      req.callbackSuccess = function (response: any) {
        // self.getUserData();
        sessionStorage.setItem("NEW_CC", JSON.stringify(response.creditcard));
        self.showModalSuccess = true;
      };
      req.callbackError = function (error: any) {
        console.log(error);
        $("#NUMBERS").removeClass("valid");
        $("#CARD_FULL_NAME").removeClass("valid");
        $("#EXPIRATION_DATE").removeClass("valid");
        $("#CVV").removeClass("valid");
        let mensagem: string;
        if (error.response.data.errorCode == 6)
          mensagem =
            "Ops! Identificamos algo de errado com suas configurações de pagamento. Gentileza consultar o administrador.";
        else if (error.response.data.errorCode == 13)
          mensagem = "O cartão informado já está em uso.";
        else
          mensagem =
            "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde.";
        self.mostraModal(mensagem);
      };
      req.loadingMessage = "Adicionando cartão...";
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
      const mensagem =
        "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde";
      this.mostraModal(mensagem);
    }
  }

  randomNumber() {
    const numeroAleatorio = Math.floor(Math.random() * 900) + 100;
    return numeroAleatorio;
  }

  validateCpf(type: string) {
    if (this.noCpf) {
      this.userData.CPF = "";
      this.oldNumberCard = this.numberCard;
      this.cpfError = "";
      this.documentType = "CPF";
      this.fechaModalCpf();
      this.addCreditCard();
    } else {
      const cpf = this.cpf.replace(/[^\d]+/g, "");
      if (cpf == "") {
        this.cpfError = "Digite um cpf válido";
        return false;
      }
      // Elimina CPFs invalidos conhecidos
      if (
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      ) {
        this.cpfError = "Digite um cpf válido";
        return false;
      }
      // Valida 1o digito
      let add = 0;
      for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
      let rev = 11 - (add % 11);
      if (rev == 10 || rev == 11) rev = 0;
      if (rev != parseInt(cpf.charAt(9))) {
        this.cpfError = "Digite um cpf válido";
        return false;
      }
      // Valida 2o digito
      add = 0;
      for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11) rev = 0;
      if (rev != parseInt(cpf.charAt(10))) {
        this.cpfError = "Digite um cpf válido";
        return false;
      } else {
        this.cpfValidDis = false;
        if (type == "half") {
          return true;
        } else {
          this.userData.CPF = cpf;
          this.oldNumberCard = this.numberCard;
          this.cpfError = "";
          this.documentType = "CPF";
          this.fechaModalCpf();
          this.addCreditCard();
        }
      }
    }
  }

  getUserData() {
    const self = this;
    const req = new Request();
    req.body = {
      USER_ID: sessionStorage.getItem("USER_ID") || "",
      NRORG: sessionStorage.getItem("NRORG"),
      TOKEN: sessionStorage.getItem("TOKEN") || "",
      USER_TYPE_ID: 1,
      TOKEN_EXT: sessionStorage.getItem("TOKEN_EXT" || ""),
    };
    req.route = "getUserData";
    req.callbackSuccess = function (response: any) {
      const now: any = moment();
      sessionStorage.setItem("USER_DATA", JSON.stringify(response.user));
      sessionStorage.setItem("LAST_GET_USER_DATA", now);
    };
    req.callbackError = function (error: any) {
      console.log(error);
    };
    req.send();
  }

  mostraModal(message: string) {
    this.errorMessage = message;
    this.showModal = true;
  }

  mostraModalCpf(message: string) {
    this.errorMessage = message;
    this.showModalCpf = true;
  }

  fechaModalCpf() {
    this.showModalCpf = false;
  }

  mostraModalEmail(message: string) {
    this.errorMessage = message;
    this.showModalEmail = true;
  }

  fechaModalEmail() {
    this.showModalEmail = false;
  }

  fechaModal() {
    this.showModal = false;
  }

  fechaModalSuccess() {
    this.showModal = false;
    this.$router.push({ name: "PaymentMethod" });
  }

  validateEmail() {
    const emailRegex = new RegExp(
      // eslint-disable-next-line
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (!emailRegex.test(this.email)) {
      this.emailError = "Endereço de email inválido.";
      return false;
    } else {
      this.profile.EMAIL = this.email;
      this.oldNumberCard = this.numberCard;
      this.cpfError = "";
      this.fechaModalEmail();
      this.addCreditCard();
    }
  }

  validateField(fieldId: string) {
    const fieldValue = String($("#" + fieldId).val());
    if (
      fieldValue.includes("_") ||
      fieldValue.length == 0 ||
      fieldValue == "" ||
      fieldValue == null ||
      fieldValue == undefined ||
      fieldValue == "undefined"
    ) {
      $("#" + fieldId).removeClass("valid");
      $("#" + fieldId).addClass("invalid");
      this.fullNameValid = false;
      this.cvvValid = false;
    } else {
      $("#" + fieldId).removeClass("invalid");
      $("#" + fieldId).addClass("valid");
      this.fullNameValid = true;
      this.cvvValid = true;
    }
  }

  validateCardNumber(cc: any) {
    const CC = String(cc.split(" ")).replace(/,/g, "");
    const self = this;
    const cartoes = {
      regexVisa: /^4[0-9]{1}(?:[0-9]{3})?/,
      regexMaster:
        /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      regexAmex: /^3[47][0-9]{13}/,
      regexDiners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
      regexElo:
        /^(40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/,
    };

    function validateCC(nr: any, cartoes: any) {
      for (const cartao in cartoes) {
        if (nr.match(cartoes[cartao])) {
          $("#NUMBERS").removeClass("invalid");
          $("#NUMBERS").addClass("valid");
          self.numberCardValid = true;
          self.verifyCardFlag();
          break;
        } else {
          self.numberCardValid = false;
          $("#NUMBERS").removeClass("valid");
          $("#NUMBERS").addClass("invalid");
        }
      }
    }

    if (this.flagVr != "VOUCHER") {
      validateCC(CC, cartoes);
    }
  }

  numberCardValidate() {
    this.validateCardNumber(this.numberCard);
    if (this.numberCardValid == true) {
      this.numberCardValidDis = false;
      return true;
    } else {
      this.numberCardValidDis = true;
      return false;
    }
  }

  fullNameValidate() {
    this.validateField("CARD_FULL_NAME");
    if (this.fullNameValid == true) {
      this.fullNameValidDis = false;
      return true;
    } else {
      this.fullNameValidDis = true;
      return false;
    }
  }

  cvvValidate() {
    this.validateField("CVV");
    if (this.cvvValid == true) {
      this.cvvValidDis = false;
      return true;
    } else {
      this.cvvValidDis = true;
      return false;
    }
  }

  expiryDateValidate() {
    this.verifyExpiryDate("EXPIRATION_DATE");
    if (this.expiryDateValid == true) {
      this.expiryDateValidDis = false;
      return true;
    } else {
      this.expiryDateValidDis = true;
      return false;
    }
  }

  verifyExpiryDate(field: string) {
    const fieldValue = String($("#" + field).val());
    const expiryDate = fieldValue.split(" ")[0];
    const monthExpiry = moment(expiryDate).month();

    if (!monthExpiry) {
      $("#" + field).removeClass("valid");
      $("#" + field).addClass("invalid");
      this.expiryDateValid = false;
    } else {
      $("#" + field).removeClass("invalid");
      $("#" + field).addClass("valid");
      this.expiryDateValid = true;
    }
  }

  verifyCardFlag() {
    const cardNumber = this.numberCard.replace(/ /g, "").replace(/_/g, "");
    const regexVisa = /^4[0-9]{1}(?:[0-9]{3})?/;
    const regexMaster =
      /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/;
    const regexAmex = /^3[47][0-9]{1}/;
    const regexDiners = /^3(?:0[0-5]|[68][0-9])[0-9]{1}/;
    const regexElo =
      /^(40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/;
    const valeRefeicao = this.flagVr;

    if (valeRefeicao == "VOUCHER") {
      this.flagCard = "VOUCHER";
      this.cardFlag = "VOUCHER";
    } else if (regexVisa.test(cardNumber)) {
      this.flagCard = "Visa";
      this.cardFlag = "Visa";
    } else if (regexMaster.test(cardNumber)) {
      this.flagCard = "Master Card";
      this.cardFlag = "MasterCard";
    } else if (regexAmex.test(cardNumber)) {
      this.flagCard = "Amex";
      this.cardFlag = "Amex";
    } else if (regexDiners.test(cardNumber)) {
      this.flagCard = "Diners";
      this.cardFlag = "Diners";
    } else if (regexElo.test(cardNumber)) {
      this.flagCard = "Elo";
      this.cardFlag = "Elo";
    } else this.cardFlag = "";

    if (this.flagCard) {
      if (this.flagCard === "VOUCHER") {
        $("#FLAG").val(sessionStorage.getItem("VOUCHER_FLAG") || "VOUCHER");
      } else {
        $("#FLAG").val(this.flagCard);
      }
      //SelectFieldController.refresh();
    }
  }

  expirationDateOut() {
    this.verifyExpiryDate("EXPIRATION_DATE");
  }

  flagChange() {
    $("#FLAG").addClass("valid");
  }

  data() {
    return {
      structures: [
        { id: "1", name: "Master Card" },
        { id: "2", name: "Visa" },
        { id: "3", name: "Amex" },
        { id: "4", name: "Hipercard" },
        { id: "5", name: "Diners" },
        { id: "6", name: "Aura" },
        { id: "7", name: "Elo" },
        { id: "8", name: "Alelo" },
        { id: "9", name: "Sodexo" },
      ],
    };
  }

  goBack() {
    this.clearVr();
    this.$router.go(-1);
  }

  goTo() {
    this.$router.push("NewCardSuccess");
  }

  buildCardView() {
    const card = new Card({
      // a selector or DOM element for the form where users will
      // be entering their information
      form: "form", // *required*
      // a selector or DOM element for the container
      // where you want the card to appear
      container: ".card-wrapper", // *required*

      formSelectors: {
        numberInput: "input#NUMBERS", // optional — default input[name="number"]
        expiryInput: "input#EXPIRATION_DATE", // optional — default input[name="expiry"]
        cvcInput: "input#CVV", // optional — default input[name="cvc"]
        nameInput: "input#CARD_FULL_NAME", // optional - defaults input[name="name"]
      },

      width: 300, // optional — default 350px
      formatting: true, // optional - default true

      // Strings for translation - optional
      messages: {
        validDate: "valid\ndate", // optional - default 'valid\nthru'
        monthYear: "mm/yyyy", // optional - default 'month/year'
      },

      // Default placeholders for rendered fields - optional
      placeholders: {
        number: "•••• •••• •••• ••••",
        name: "Nome Impresso no cartão",
        expiry: "••/••",
        cvc: "•••",
      },

      masks: {
        cardNumber: "•", // optional - mask card number
      },

      // if true, will log helpful messages for setting up Card
      debug: false, // optional - default false
    });
  }

  focusInput(id: any) {
    const offset = -60;
    const el: any = $("#" + id);
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: el.offset().top + offset,
        },
        100
      );
    }, 150);
  }

  clearVr() {
    this.flagVr = null;
    sessionStorage.setItem("FLAG_VR", "");
  }

  dontHaveCpf(noCpf: boolean) {
    if (noCpf) {
      this.disabledCpfField = true;
      this.cpfValidDis = false;
    } else {
      this.disabledCpfField = false;
      if (this.cpf == "") {
        this.cpfValidDis = true;
      } else {
        if (this.validateCpf("half") == true) {
          this.cpfValidDis = false;
        } else {
          this.cpfValidDis = true;
        }
      }
    }
  }
}
